import(/* webpackMode: "eager" */ "/vercel/path0/app/tim/page.tsx");
